import { useState } from 'react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Search, Loader2, Package } from 'lucide-react';
import { STATUS_LABELS, STATUS_COLORS, STATUS_FLOW } from '@/lib/constants';
import { getCurrencySymbol, convertPrice } from '@/lib/cartStore';
import { PushOptIn } from '@/components/PushOptIn';

export default function TrackOrder() {
  const [num, setNum] = useState('');
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const search = async (e) => {
    e.preventDefault(); if (!num.trim()) return;
    setLoading(true); setError(''); setOrder(null);
    try { const { data } = await api.get(`/orders/track/${num.trim()}`); setOrder(data); }
    catch { setError('No se encontró ningún pedido con ese número.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-xl mx-auto px-4 py-12">
      <h1 className="font-heading font-bold text-2xl text-[#1a3a5c] mb-6 flex items-center gap-2"><Package className="h-6 w-6" /> Rastrear Pedido</h1>
      <form onSubmit={search} className="flex gap-2 mb-8">
        <Input value={num} onChange={(e) => setNum(e.target.value)} placeholder="Ej: BMB-10001" data-testid="track-input" />
        <Button type="submit" className="bg-[#1a3a5c] hover:bg-[#1a3a5c]/90 gap-1"><Search className="h-4 w-4" /> Buscar</Button>
      </form>
      <div className="mb-8 flex justify-center empty:hidden"><PushOptIn variant="outline" /></div>
      {loading && <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-[#1a3a5c]" /></div>}
      {error && <p className="text-center text-sm text-red-600">{error}</p>}
      {order && (
        <div className="bg-card rounded-xl border border-border p-6">
          <div className="flex items-center justify-between mb-4"><div><p className="font-bold text-foreground">{order.order_number}</p><p className="text-xs text-muted-foreground">{new Date(order.created_at).toLocaleDateString('es')}</p></div><Badge className={STATUS_COLORS[order.status]}>{STATUS_LABELS[order.status]}</Badge></div>
          <div className="space-y-3 mb-4">
            {STATUS_FLOW.filter((s) => s !== 'cancelled').map((s) => {
              const done = STATUS_FLOW.indexOf(s) <= STATUS_FLOW.indexOf(order.status);
              return (<div key={s} className="flex items-center gap-3"><div className={`w-3 h-3 rounded-full ${done ? 'bg-green-600' : 'bg-muted'}`} /><span className={`text-sm ${done ? 'text-foreground font-medium' : 'text-muted-foreground'}`}>{STATUS_LABELS[s]}</span></div>);
            })}
          </div>
          <p className="border-t border-border pt-3 text-sm text-muted-foreground" data-testid="tracking-privacy-note">El rastreo público solo muestra estados. Consulta los datos personales e importes en <a href="/mis-pedidos" className="underline" data-testid="tracking-my-orders">Mis pedidos</a> con tu sesión.</p>
        </div>
      )}
    </div>
  );
}
